module.exports = __webpack_public_path__ + "img/main_boses.539fd0cb.jpg";